export class Microsoft365EntityFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "protectionStatus",
            "baseName": "protectionStatus",
            "type": "SaasProtectionStatusFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365EntityFilters.attributeTypeMap;
    }
    constructor() {
    }
}
